import { Typo } from 'components/ui-kit';
import { useField } from 'formik';
import { MoneyFormatter } from 'lib';
import styles from './certificate-card.module.scss';
import { initialValuesForm } from '../certificate-form.const';

export const CertificateCard = (): JSX.Element => {
  const [amount] = useField<string | undefined>('total');
  const [message] = useField<string | undefined>('message');

  return (
    <div className={styles.certificateCard}>
      <img
        className={styles.logo}
        src="/images/page/certificate/univermag-logo.svg"
        alt="Логотип Универмага"
      />
      <div className={styles.amount}>
        {MoneyFormatter.format(Number(amount.value) ?? initialValuesForm.total)}
        <br />
        на покупки
      </div>
      <div className={styles.messageContainer}>
        <Typo weight="700">Текст вашего поздравления:</Typo>
        <div className={styles.message}>{message?.value}</div>
      </div>
      <div className={styles.promocode}>********</div>
      <Typo variant="xm">
        Введите промокод при оплате
        <br />
        покупки на shop.tochka.com
      </Typo>
    </div>
  );
};
